module.exports = __webpack_public_path__ + "static/3dmodel04-9e88542b4e2caf95e4e9c78f434f589f.jpg";